import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import ResetPassword from '@/components/ResetPassword'
import ForgotPassword from '@/components/ForgotPassword'
import EmailConfirmation from '@/components/EmailConfirmation'
import Dashboard from '@/components/Dashboard'
import Overview from '@/components/Overview'
import Profile from '@/components/users/Profile'
import NotFound from '@/components/NotFound'
import Unauthorized from '@/components/Unauthorized'

import ServiceFactory from '../shared/service-clients/serviceClientFactory'
import {SessionServiceClient} from '../shared/service-clients/service-clients'

import store from '../store'
import usersRoutes from './users'
import projectsRoutes from './projects'
import entrepreneursRoutes from './entrepreneurs'
import membersRoutes from './members'
import investmentsRoutes from './investments'
import partnerRoutes from './partners'
import exitRoutes from './exits'
import rolesRoutes from './roles'
import permission from '../shared/permission'
import eventsRoutes from './events'
import dashboardRoutes from './dashboard'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
    },
    {
      name: 'Login',
      path: '/login',
      component: Login,
    },
    {
      name: 'EmailConfirmation',
      path: '/emailConfirmation/:code',
      component: EmailConfirmation,
      meta: {public: true},
    },
    {
      name: 'ForgotPassword',
      path: '/forgotPassword',
      component: ForgotPassword,
      meta: {public: true},
    },
    {
      name: 'ResetPassword',
      path: '/resetPassword/:code',
      component: ResetPassword,
      meta: {public: true},
    },
    {
      name: 'NotFound',
      path: '/notFound',
      component: NotFound,
    },
    {
      name: 'Unauthorized',
      path: '/unauthorized',
      component: Unauthorized,
    },
    {
      path: '/dashboard',
      component: Dashboard,
      children: [
        {
          meta: {title: 'menu.dashboard', ico: 'dashboard'},
          name: 'Dashboard',
          path: '/dashboard',
          component: Overview,
        },
        {
          name: 'Profile',
          path: '/profile',
          component: Profile,
        },
      ].concat(
        membersRoutes,
        entrepreneursRoutes,
        partnerRoutes,
        projectsRoutes,
        investmentsRoutes,
        exitRoutes,

        rolesRoutes,
        usersRoutes,
        eventsRoutes,

        dashboardRoutes
      ),
    },
  ],
})

let routingRedirect = function(isLoggedIn, to, next) {
  if (!to.matched.length) {
    next('/notFound')
  } else if (to.meta.public) {
    next()
  } else if (isLoggedIn && to.path != '/login') {
    var prop = to.meta.permission
    if (prop == null || permission.checkPermission(prop)) {
      next()
    } else {
      next('/unauthorized')
    }
  } else if (isLoggedIn && to.path == '/login') {
    next('/dashboard')
  } else if (!isLoggedIn && to.path == '/login') {
    next() //This is not a duplicate, next(/login) will get you into an infinite loop
  } else {
    next('/login')
  }
}

router.beforeEach((to, from, next) => {
  var isLoggedIn = store.state.isLoggedIn
  var shouldBeLoggedIn = Vue.cookie.get('userId') != null

  store.commit('clearFiles')

  //Validate with server if the user is really logged-in
  if (shouldBeLoggedIn && !isLoggedIn) {
    var sessionService = ServiceFactory.create(SessionServiceClient)

    sessionService
      .getCurrentLoginInformations()
      .then(res => {
        if (res.user) {
          store.commit('login', {currentUser: res.user})
          isLoggedIn = true
        }
      })
      .catch(err => {
        console.log(err)
        store.commit('logout')
        isLoggedIn = true
      })
      .then(() => {
        routingRedirect(isLoggedIn, to, next)
      })
  } else {
    routingRedirect(isLoggedIn, to, next)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js